// src/pages/expense/env/disinfection/ExpenseEnvDisinfectionDraftList.jsx
// ✅ 전 사업 확산 [2] — 환경/소독 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은
// 환경/소독 전용 config(envDisinfectionConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftList from "../../_shared/ExpenseDraftList";
import envDisinfectionConfig from "./envDisinfectionConfig";

export default function ExpenseEnvDisinfectionDraftList() {
  return <ExpenseDraftList config={envDisinfectionConfig} />;
}
